import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const modalFlexContent = css`
  flex: 1;
  overflow-x: visible;
  overflow-y: auto;
  position: relative;
  padding: ${theme.spacing(1)} ${theme.spacing(3)};
  grid-row-start: body-start;
  grid-row-end: body-end;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;
